export const status = {
	open: 'Abierto',
	close: 'Cerrado',
};
